import { Content } from "@/ui";
import { hospitality_and_catering_pages_helper } from "@/helpers/hospitality_and_catering_pages_helper";
import { sector_helper } from "@/helpers/sector_helper";
import { createTitle } from "@/functions/createTitle";
import { trimText } from "@/functions/trimText";
import { getRoute } from "@/getters/getRoute";
import { getSectorStaticProps } from "@/functions/getSectorStaticProps";

export default function CateringSectorPage({ content}) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const sector = sector_helper.find("42ee49b6-cfc2-4b42-a5b5-cf9a17009a6f", "id");
  const pages_helper = hospitality_and_catering_pages_helper.fetch({ parent: null });

  return {
    props: {
      meta: {
        title: createTitle(`${sector.title} Jobs`),
        canonical: "https://www.bluearrow.co.uk" + getRoute("/drivingjobs/")
      },
      content:  [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [{ label: sector.title, href: getRoute("sector", { url_slug: sector.url_slug }) }],
          },
        },
        {
          component: "Header",
          props: {
            className: "text-tertiary",
            title: { path: `page.${sector.url_slug}.component.Header.title`, placeholder: sector.title },
            description: { path: `page.${sector.url_slug}.component.Header.description` },
            img: sector.cover_image ?? null,
            variant: "50/50",
            back: {
              path: `page.home.component.Header.back`,
              placeholder: `Back to Home`,
              href: getRoute("home"),
            },
          },
        },
        {
          component: "JobsFeed",
          id: "Jobs",
          props: { sector: sector.id, changeURLOnFilterChange: false },
        },
        {
          component: "PromoSection",
          props: {
            title: { path: `page.${sector.url_slug}.component.PromoSection.title`, placeholder: "Also in this section" },
            items: pages_helper.map((i) => ({
              title: i.name,
              description: trimText(i.body),
              img: i.cover_image ?? null,
              href: getRoute("sectorPage", { sector: sector.url_slug, page: i.url_slug }),
            })),
            md: 3,
          },
        },
        {
          component: "RichText",
          props: {
            className: "mb-4",
            containerClassName: null,
            body: sector.footer_content ?? null,
          },
        },
      ],
    },
  };
// export async function getStaticProps() {
//   return getSectorStaticProps({
//     sector_id: "42ee49b6-cfc2-4b42-a5b5-cf9a17009a6f",
//     pages_helper: hospitality_and_catering_pages_helper,
//   });
// }
}

